import { useCommunicationsModalStore } from "./communications-modal.store";

export function useCommunicationsModal() {
  const open = useCommunicationsModalStore((s) => s.open);
  const close = useCommunicationsModalStore((s) => s.close);

  return {
    open,
    close,
  };
}
